import React, { useState, useRef } from 'react';
import Layout from 'layouts/manager/Layout';
import Form, { SupporterFormValues } from './Form';

const Edit: React.FC = () => {
  const [form, setForm] = useState<SupporterFormValues>({
    email: '',
    name: '',
    displayName: '',
    company: '',
    post1: '',
    post2: '',
    pref: '',
    city: '',
    address1: '',
    address2: '',
    tel: '',
    mobile: '',
    logo: null,
    reportTypes: [],
    estimateEdit: '',
  });
  const logoInputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    if (type === 'checkbox' && name === 'reportTypes') {
      const checked = (e.target as HTMLInputElement).checked;
      setForm(prev => ({
        ...prev,
        reportTypes: checked
          ? [...prev.reportTypes, value]
          : prev.reportTypes.filter(v => v !== value),
      }));
    } else if (type === 'radio' && name === 'estimateEdit') {
      setForm(prev => ({ ...prev, estimateEdit: value }));
    } else if (type === 'file') {
      const input = e.target as HTMLInputElement;
      setForm(prev => ({ ...prev, logo: input.files && input.files[0] ? input.files[0] : null }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleLogoClear = () => {
    setForm(prev => ({ ...prev, logo: null }));
    if (logoInputRef.current) logoInputRef.current.value = '';
  };

  return (
    <Layout>
      <div className="flex items-center justify-between mx-auto mb-8">
        <h1 className="text-2xl font-bold text-gray-800">協力パートナー管理</h1>
      </div>
      <div className="p-8 mx-auto bg-white border border-gray-200 rounded-lg shadow-md">
        <div className="mb-3">
          <a href="/manager/supporter" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
        </div>
        <div className="mb-6">
          <h2 className="flex items-center justify-between w-full pt-1 pb-2 text-lg font-bold text-left text-gray-800 border-b border-gray-200">
            協力パートナー情報編集
          </h2>
        </div>
        <Form
          form={form}
          setForm={setForm}
          handleChange={handleChange}
          handleLogoClear={handleLogoClear}
          logoInputRef={logoInputRef}
          showPasswordFields={false}
        />
        <div className="flex items-center justify-between gap-4 mt-8">
          <a href="/manager/supporter" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
          <button type="submit" className="px-6 py-2 min-w-[120px] font-semibold text-white rounded bg-primary hover:bg-[#001b40] transition text-sm shadow">保存</button>
        </div>
      </div>
    </Layout>
  );
};

export default Edit;
